module.exports = __webpack_public_path__ + "img/gallery-image-32.cb0a7d9c.jpg";